module.exports = __webpack_public_path__ + "static/img/semi-heavy-horse-green.6a2c2ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/semi-heavy-horse-green.svg
// module id = /c7Q
// module chunks = 74